export const HORIZONTAL_PADDING = 24;
export const HORIZONTAL_PADDING_MOBILE = 16;
